import Service, { service } from '@ember/service';
import Settings from 'donor-elf-web/services/settings';

const REPORT_LABELS = {
  'tenfold-paystubs': 'Paystubs',
  'pbt-disbursement-availability': 'Disbursement Availability',
  'pbt-disbursement-summary': 'Disbursement Summary',
} as Record<string, string>;

// TODO: it seems there are 2 places for custom reports. Fund Setting and User Setting
export default class CustomReportsService extends Service {
  @service declare settings: Settings;

  // returns [{ label: '', routeName: '' }]
  get reports() {
    return this.settings.userSettings?.customReports?.map(
      (reportRouteName: string, _index: number) => {
        return {
          label: REPORT_LABELS[reportRouteName],
          routeName: `funds.fund.custom-reports.${reportRouteName}`,
        };
      },
    );
  }
}
